let nextUid = 0;
function uid() {
  return ++nextUid;
}
export {
  uid
};
//# sourceMappingURL=uid.mjs.map
